import React, { useState } from "react";
import { Section } from "@atoms/Section";
import Text from "@ds/components/Text";
import color from "@definitions/mui/color";
import { Box } from "@mui/material";
import useAction from "@containers/About/hooks/useAction";
import dayjs from "dayjs";
import Button from "@ds/components/Button";
import { useTranslation } from "next-i18next";
import sanitizeHtml from "sanitize-html";
import { useRouter } from "next/router";

const SuccessStoryPartial: React.FC = () => {
  const { insightList } = useAction();
  const [seeAll, setSeeAll] = useState(false);
  const { t } = useTranslation("common");
  const router = useRouter();

  return (
    <Section
      pt="32px"
      pb="132px"
      sx={{
        "& > div": {
          padding: 0,
        },
      }}
    >
      <Box
        pt="32px"
        mx="16px"
        sx={{
          borderTop: `1px solid ${color.grey.light}`,
        }}
      >
        <Text
          weight="700"
          variant="h3"
          sx={{
            marginBottom: "24px",
            lineHeight: "26px",
            textAlign: "center",
          }}
        >
          {t("about.successStory")}
        </Text>
        <Box
          sx={{
            "& > div": {
              "& + div": {
                marginTop: "12px",
              },
            },
            marginBottom: 3,
          }}
        >
          {insightList?.data.slice(0, seeAll ? insightList.data.length : 2).map((data, i) => (
            <Box
              border={`1px solid ${color.grey.light}`}
              borderRadius="8px"
              key={i}
              onClick={() => router.push("/insight")}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "120px",
                  backgroundImage: `url("${data.imageUrl.mediaPath}")`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                }}
              />
              <Box p="8px 12px 12px" display="flex" flexDirection="column">
                <Text
                  weight="600"
                  variant="h3"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                >
                  {data.title}
                </Text>
                <Text
                  weight="400"
                  variant="body2"
                  sx={{
                    margin: "8px 0",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "20px",
                    textAlign: "justify",
                  }}
                >
                  {sanitizeHtml(data.story, {
                    allowedTags: [],
                    allowedAttributes: {},
                  })}
                </Text>
                <Text
                  weight="400"
                  variant="body2"
                  sx={{
                    color: color.inactive.secondary,
                    lineHeight: "16px",
                  }}
                >
                  {dayjs(data.date).format("DD MMM YYYY")}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>
        {!seeAll && (
          <Button fullWidth variant="secondary" size="medium" onClick={() => setSeeAll(true)}>
            {t("viewAll")}
          </Button>
        )}
      </Box>
    </Section>
  );
};

export default SuccessStoryPartial;
